var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"byType",staticStyle:{"min-height":"350px"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{ref:"legend",staticClass:"col-8"}),_vm._v(" "),_c('div',{ref:"legend2",staticClass:"col-4"})])])}
var staticRenderFns = []

export { render, staticRenderFns }